import React, { useState, useEffect, useCallback } from 'react';
import './index.scss';
import api from '../../../api.js';
import Rodape from '../../../components/Rodape/index.js';
import MenuLateral from '../../../components/MenuLateral/index.js';
import Cabecalho from '../../../components/Cabecalho/index.js';
import { useAuth } from '../../../context/AuthContext.js';
import { useToast } from '../../../context/ToastContext.js';

export default function ConfiguracoesPagamento() {
    const { nivelAcesso } = useAuth();
    const { showToast } = useToast();

    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [testando, setTestando] = useState(false);

    const [config, setConfig] = useState({
        handle: '',
        redirect_url: '',
        webhook_url: '',
        ambiente: 'sandbox',
        pix_habilitado: true,
        cartao_habilitado: true,
        boleto_habilitado: false,
        ativo: false
    });

    const carregarConfig = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get('/pagamento/admin/config');
            if (response.data.success && response.data.config) {
                setConfig(prev => ({
                    ...prev,
                    ...response.data.config,
                    handle: response.data.config.handle || '',
                    redirect_url: response.data.config.redirect_url || '',
                    webhook_url: response.data.config.webhook_url || '',
                }));
            }
        } catch (error) {
            if (error.response?.status !== 404) {
                showToast('Erro ao carregar configurações de pagamento', 'error');
            }
        } finally {
            setLoading(false);
        }
    }, [showToast]);

    useEffect(() => {
        if (nivelAcesso !== 'Administrador') {
            window.location.href = '/';
            return;
        }
        carregarConfig();
    }, [nivelAcesso, carregarConfig]);

    const salvarConfig = async () => {
        setSalvando(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        try {
            const response = await api.put('/pagamento/admin/config', config);
            if (response.data.success) {
                showToast('Configurações salvas com sucesso!', 'success');
                carregarConfig();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar configurações', 'error');
        } finally {
            setSalvando(false);
        }
    };

    const testarConexao = async () => {
        setTestando(true);
        try {
            const response = await api.post('/pagamento/admin/testar');
            if (response.data.success) {
                showToast(response.data.message, 'success');
            } else {
                showToast(response.data.message, 'error');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao testar conexão', 'error');
        } finally {
            setTestando(false);
        }
    };

    const handleChange = (campo, valor) => {
        setConfig(prev => ({ ...prev, [campo]: valor }));
    };

    const handleToggle = (campo) => {
        setConfig(prev => ({ ...prev, [campo]: !prev[campo] }));
    };

    return (
        <section className='container-principal-pagamento-config'>
            <Cabecalho />
            <main className='main-pagamento-config'>
                <MenuLateral />
                <section className='conteudo-pagamento-config'>
                    <div className='titulo-pagamento-config'>
                        <h1>Configurações de Pagamento</h1>
                        <span>InfinitePay — Checkout Link (PIX e Cartão)</span>
                    </div>

                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando configurações...</h2>
                        </div>
                    ) : (
                    <>
                    {/* STATUS DO GATEWAY */}
                    <div className='card-status-gateway'>
                        <div className='cabecalho-status-gateway'>
                            <p><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Status do Gateway</p>
                            <div style={{ backgroundColor: config.ativo ? '#4CAF50' : '#FF9800' }}><strong>
                                {config.ativo ? ' Ativo' : ' Inativo'}  </strong></div>
                        </div>
                        <div className='container-interno'>
                            <div className='status-container'>
                                <div className='info-manutencao'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15H11V17H9V15ZM9 5H11V13H9V5Z" fill="#F57C00" />
                                    </svg>
                                    <p>{config.ativo
                                        ? `Ambiente: ${config.ambiente === 'production' ? 'Produção' : 'Sandbox (Teste)'}`
                                        : 'Configure suas credenciais e ative o gateway para receber pagamentos.'
                                    }</p>
                                </div>
                                <label className='toggle-option'>
                                    <input
                                        type='checkbox'
                                        checked={config.ativo}
                                        onChange={() => handleToggle('ativo')}
                                    />
                                    <span>{config.ativo ? 'Gateway Ativo' : 'Gateway Inativo'}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* CONFIGURACAO */}
                    <div className='card-credenciais'>
                        <div className='cabecalho-credenciais'>
                            <p><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 2L19 4M11.3891 11.6109C12.3844 12.6062 13 13.9812 13 15.5C13 18.5376 10.5376 21 7.5 21C4.46243 21 2 18.5376 2 15.5C2 12.4624 4.46243 10 7.5 10C9.01878 10 10.3938 10.6156 11.3891 11.6109ZM11.3891 11.6109L15.5 7.5M15.5 7.5L18.5 10.5L22 7L19 4M15.5 7.5L19 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Configuração InfinitePay</p>
                        </div>
                        <div className='container-interno'>
                            <div className='form-group'>
                                <label>Handle (InfiniteTag sem $)</label>
                                <input
                                    type="text"
                                    placeholder="Exemplo: fracaro-store"
                                    value={config.handle}
                                    onChange={(e) => handleChange('handle', e.target.value)}
                                />
                            </div>

                            <div className='form-group'>
                                <label>URL de Redirecionamento (opcional)</label>
                                <input
                                    type="text"
                                    placeholder="https://seusite.com/pagamento-concluido"
                                    value={config.redirect_url}
                                    onChange={(e) => handleChange('redirect_url', e.target.value)}
                                />
                            </div>

                            <div className='form-group'>
                                <label>Webhook URL (opcional)</label>
                                <input
                                    type="text"
                                    placeholder="https://seusite.com/pagamento/webhook"
                                    value={config.webhook_url}
                                    onChange={(e) => handleChange('webhook_url', e.target.value)}
                                />
                                <small>URL do webhook: <code>{window.location.origin.replace('3000', '3001')}/pagamento/webhook</code></small>
                            </div>
                        </div>
                    </div>

                    {/* AMBIENTE */}
                    <div className='card-ambiente'>
                        <div className='cabecalho-ambiente'>
                            <p><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 12H22" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Ambiente</p>
                        </div>
                        <div className='container-interno'>
                            <div className='radio-group'>
                                <label className='radio-option'>
                                    <input
                                        type='radio'
                                        value='sandbox'
                                        checked={config.ambiente === 'sandbox'}
                                        onChange={(e) => handleChange('ambiente', e.target.value)}
                                    />
                                    <span className='radio-circle sandbox'></span>
                                    Sandbox (Teste)
                                </label>
                                <label className='radio-option'>
                                    <input
                                        type='radio'
                                        value='production'
                                        checked={config.ambiente === 'production'}
                                        onChange={(e) => handleChange('ambiente', e.target.value)}
                                    />
                                    <span className='radio-circle producao'></span>
                                    Produção
                                </label>
                            </div>

                            <div className='info-manutencao'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15H11V17H9V15ZM9 5H11V13H9V5Z" fill="#F57C00" />
                                </svg>
                                <p>Use Sandbox para testes e Produção quando estiver pronto para receber pagamentos reais.</p>
                            </div>
                        </div>
                    </div>

                    {/* MÉTODOS DE PAGAMENTO */}
                    <div className='card-metodos'>
                        <div className='cabecalho-metodos'>
                            <p><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Métodos de Pagamento</p>
                        </div>
                        <div className='container-interno'>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={config.pix_habilitado}
                                    onChange={() => handleToggle('pix_habilitado')}
                                />
                                <span>PIX — Pagamento instantâneo via QR Code</span>
                            </label>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={config.cartao_habilitado}
                                    onChange={() => handleToggle('cartao_habilitado')}
                                />
                                <span>Cartão de Crédito — Visa, Mastercard, Elo e outras bandeiras</span>
                            </label>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={config.boleto_habilitado}
                                    onChange={() => handleToggle('boleto_habilitado')}
                                />
                                <span>Boleto Bancário — Pagamento via boleto (prazo de 1-3 dias)</span>
                            </label>
                        </div>
                    </div>

                    {/* AÇÕES */}
                    <div className='card-acoes'>
                        <button
                            className='btn-salvar'
                            onClick={salvarConfig}
                            disabled={salvando}
                        >
                            {salvando ? 'Salvando...' : <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M17 21V13H7V21" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M7 3V8H15" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Salvar Configurações</>}
                        </button>
                        <button
                            className='btn-testar'
                            onClick={testarConexao}
                            disabled={testando || !config.ativo}
                        >
                            {testando ? 'Testando...' : <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.479 3.53087C19.552 2.60383 18.2979 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.47L11.75 5.18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 11C13.5705 10.4259 13.0226 9.9509 12.3934 9.60707C11.7643 9.26324 11.0685 9.05886 10.3533 9.00765C9.63821 8.95643 8.92043 9.05963 8.24866 9.3102C7.5769 9.56077 6.96689 9.95296 6.46 10.46L3.46 13.46C2.54918 14.403 2.0452 15.666 2.0566 16.977C2.068 18.288 2.59384 19.542 3.52088 20.4691C4.44791 21.3961 5.70198 21.922 7.01296 21.9334C8.32394 21.9448 9.58694 21.4408 10.53 20.53L12.24 18.82" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Testar Conexão</>}
                        </button>
                    </div>

                    {/* COMO CONFIGURAR */}
                    <div className='card-instrucoes'>
                        <div className='cabecalho-instrucoes'>
                            <p><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> Como Configurar</p>
                        </div>
                        <div className='container-interno'>
                            <div className='passos-config'>
                                <div className='passo'>
                                    <div className='passo-numero'>1</div>
                                    <div className='passo-info'>
                                        <strong>Crie uma conta no InfinityPay</strong>
                                        <p>Acesse <a href="https://infinitypay.io" target="_blank" rel="noopener noreferrer">infinitypay.io</a> e cadastre seu CNPJ.</p>
                                    </div>
                                </div>
                                <div className='passo'>
                                    <div className='passo-numero'>2</div>
                                    <div className='passo-info'>
                                        <strong>Informe sua Handle</strong>
                                        <p>Use sua InfiniteTag sem o símbolo $ (ex.: fracaro-store).</p>
                                    </div>
                                </div>
                                <div className='passo'>
                                    <div className='passo-numero'>3</div>
                                    <div className='passo-info'>
                                        <strong>Configure URLs opcionais</strong>
                                        <p>Defina redirect_url para retorno ao site e webhook_url para confirmação automática.</p>
                                    </div>
                                </div>
                                <div className='passo'>
                                    <div className='passo-numero'>4</div>
                                    <div className='passo-info'>
                                        <strong>Ative o gateway</strong>
                                        <p>Marque o gateway como ativo para gerar links de checkout no pedido.</p>
                                    </div>
                                </div>
                                <div className='passo'>
                                    <div className='passo-numero'>5</div>
                                    <div className='passo-info'>
                                        <strong>Teste o fluxo completo</strong>
                                        <p>Finalize um pedido de teste e confirme o retorno pelo redirect_url ou webhook.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
